import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ModalComponent from '../../../../shared/components/Modal';

import * as ReportActions from '../../../../store/actions/tenant/reports';

const ReportDeletePrompt = ({
  report, onHideModal, softDeleteReport,
}) => {
  const { _id } = report || {};
  let { title } = report || {};
  title = title || _id;
  const handleDeleteConfirm = () => {
    softDeleteReport(report);
    onHideModal();
  };
  const { t } = useTranslation('common');
  return (
    <ModalComponent
      title={t('report_delete_prompt.title')}
      color="danger"
      showToggleButton={false}
      showButtons
      onToggle={onHideModal}
      showModal={!!report}
      onOk={handleDeleteConfirm}
    >
      <h4>
        {t('report_delete_prompt.message')}
      </h4>
      <p>{title}</p>
    </ModalComponent>
  );
};

ReportDeletePrompt.propTypes = {
  report: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    title: PropTypes.string,
  }),
  onHideModal: PropTypes.func.isRequired,

  softDeleteReport: PropTypes.func.isRequired,
};

ReportDeletePrompt.defaultProps = {
  report: null,
};

const mapDispatchToProps = {
  softDeleteReport: ReportActions.softDeleteReportRequest,
};

export default connect(null, mapDispatchToProps)(ReportDeletePrompt);
